import { render, staticRenderFns } from "./Payparts.vue?vue&type=template&id=436bf46e&lang=pug&"
import script from "./Payparts.vue?vue&type=script&lang=js&"
export * from "./Payparts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports